document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".footer-title").forEach(function(title) {
        title.addEventListener("click", function() {
            const section = this.parentElement.parentElement;
            section.classList.toggle("hh-active");
        });
    });

    document.body.addEventListener("click", function(event) {
        if (
            event.target.matches(".iwish-backdrop") ||
            event.target.matches(".iwish_drawer_close")
        ) {
            setTimeout(function() {
                document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {},
                    })
                );
            }, 1000);
        }
    });
});

// LOAD MORE FEATURE
function loadMoreProducts() {
    const productsOnPage = document.querySelector(".product-list");
    let nextUrl = productsOnPage?.dataset.nextUrl;

    const loadMoreBtn = document.querySelector(".load-more_btn");
    const loadMoreSpinner = document.querySelector(".load-more_spinner");
    if (!nextUrl) return;

    loadMoreBtn.style.display = "none";
    loadMoreSpinner.style.display = "block";

    fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
            loadMoreSpinner.style.display = "none";

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;

            const newProducts = tempDiv.querySelector(".product-list");
            const newUrl = newProducts?.dataset.nextUrl;

            if (newUrl) loadMoreBtn.style.display = "block";

            nextUrl = newUrl;
            productsOnPage.insertAdjacentHTML("beforeend", newProducts.innerHTML);
            const insertedCards = productsOnPage.querySelectorAll(".product-card");
            insertedCards.forEach((card) => {
                card.style.opacity = "1";
                card.style.transform = "translateY(0px)";
            });

            const descEl = document.querySelector(".hh-collection-desc");
            if (descEl) {
                descEl.style.display = "none";
            }
            productsOnPage.setAttribute("data-next-url", nextUrl);
        });
}

document.addEventListener("click", function(e) {
    if (e.target.closest(".load-more_btn")) {
        e.preventDefault();
        loadMoreProducts();
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector("#shopify-section-sections--25558505718025__header");
    if (header && !header.hasAttribute("aria-label")) {
        // header.setAttribute("role", "banner");
        header.setAttribute("aria-label", "Main Site Header");
    }

    const footer = document.querySelector(".shopify-section--footer");
    if (footer && !footer.hasAttribute("role")) {
        footer.setAttribute("role", "contentinfo");
    }
    const announcementBar = document.querySelector(".shopify-section--announcement-bar");
    if (announcementBar && !announcementBar.hasAttribute("role")) {
        announcementBar.setAttribute("aria-label", "Announcement Bar");
    }

});
// Hover Cart Drawer
// document.addEventListener("DOMContentLoaded", function () {
//   const cartLink = document.querySelector(".header__cart-link a");
//   const cartDrawer = document.querySelector("cart-drawer");

//   if (cartLink) {
//     cartLink.addEventListener("mouseenter", function () {
//       cartLink.setAttribute("aria-expanded", "true");
//       cartDrawer.show();
//     });
//   }
// });

document.addEventListener("click", function(event) {
    // Check if the clicked element matches .collection-toolbar__button
    if (event.target.closest('.collection-toolbar__button')) {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has("filter.v.availability") && urlParams.get("filter.v.availability") === "1") {
            const checkbox = document.querySelector('#filter_v_availability'); // Escape dots in ID selector
            if (checkbox) {
                checkbox.checked = true;
            }
        }
    }
});
document.addEventListener("click", function(event) {
    const popup = document.querySelector('.smartsize_pop-up');
    if (!popup) return; // exit if popup doesn't exist

    if (event.target.closest('.opensize')) {
        // toggle popup visibility
        popup.style.display = 'block';
    }

    if (event.target.closest('.ui-dialog-titlebar-close')) {
        // toggle popup visibility
        popup.style.display = 'none';
    }
});

// SELECT A VARIANT OPTION IN PRODUCT PAGE //
// ----------------START------------------ //

// V4: Form-scoped variant and purchase control lives in mk-purchase.js.

// Add shake animation CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-8px); }
    20%, 40%, 60%, 80% { transform: translateX(8px); }
  }
  
  buy-buttons button.is-disabled {
    pointer-events: none !important;
  }
`;
document.head.appendChild(style);
// SELECT A VARIANT OPTION IN PRODUCT PAGE //
// ----------------END-------------------- //

// STICKY ADD TO CART BUTTON ON PRODUCT PAGE //
// ----------------START-------------------- //
document.addEventListener('DOMContentLoaded', () => {
    const cartBlock = document.querySelector('[data-block-id="buy_buttons"] buy-buttons');
    const sticktShippingLine = document.querySelector('.sticky-shipping-line');
    const buyButtonsContainer = document.querySelector('[data-block-id="buy_buttons"]');

    if (!cartBlock || !buyButtonsContainer) return;

    const variantPicker = document.querySelector('[data-block-type="vendor"]');
    let isSticky = false;
    let lastScrollY = window.scrollY;
    let isScrollingUp = false;

    // Initialize: Fixed at bottom with mb-buy-buttons class
    // cartBlock.classList.add('mb-buy-buttons');

    // Track scroll direction
    window.addEventListener('scroll', () => {
        isScrollingUp = window.scrollY < lastScrollY;
        lastScrollY = window.scrollY;
    }, {
        passive: true
    });

    // Setup Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Container is in view, make button sticky
                if (!isSticky) {
                    isSticky = true;
                    cartBlock.classList.add('position-sticky');
                    sticktShippingLine.classList.add('position-sticky');
                }
            } else {
                // Container is NOT in view
                // Only revert to fixed if we're scrolling UPWARDS (back to top)
                if (isSticky && isScrollingUp) {
                    isSticky = false;
                    cartBlock.classList.remove('position-sticky');
                    sticktShippingLine.classList.remove('position-sticky');
                }
                // If scrolling DOWN and container is out of view (at bottom), keep it sticky
                // Do nothing - keep the sticky class
            }
        });
    }, {
        threshold: 0.1
    });

    // Start observing
    observer.observe(buyButtonsContainer);

    // Tap on the empty button → highlight the sizes (instead of always scrolling to the vendor)
    cartBlock.addEventListener('click', (e) => {
        const btn = cartBlock.querySelector('button[type="submit"]');
        if (!btn || !btn.disabled) return; // size chosen → normal add to cart
        e.preventDefault();
        const sizes = document.querySelector('.product-info__block-item .variant-picker__option-values');
        if (!sizes) return;
        const r = sizes.getBoundingClientRect();
        if (r.top < 80 || r.bottom > window.innerHeight) {
            sizes.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
        sizes.classList.remove('mk-pulse');
        void sizes.offsetWidth;
        sizes.classList.add('mk-pulse');
    });
});

// STICKY ADD TO CART BUTTON ON PRODUCT PAGE //
// ----------------END---------------------- //

// HIDE COLLECTION DESC, FAQ's UNLESS IT IS PAGE 1 //
// ---------------------START--------------------- //
(function() {
    if (window.location.pathname.includes('/products/')) return;
    
    const SELECTORS = {
        desc: ".hh-collection-desc",
        faq: ".collection-faqs",
        heading: ".hh-collection-heading",
        title: "title"
    };

    let cache = {
        elements: null,
        page: null
    };
    let originalTexts = {
        heading: null,
        title: null
    };

    function getLocale() {
        const path = window.location.pathname;
        if (path.includes('/de-de/') || path.startsWith('/de-de')) {
            return 'de';
        }
        return 'en';
    }

    function getPageText() {
        return getLocale() === 'de' ? 'Seite' : 'Page';
    }

    function getPageParam() {
        const params = new URLSearchParams(window.location.search);
        return params.get("page") || "1";
    }

    function stripPageNumber(text) {
        // Remove " – Page X", " – Seite X", or " – X" from the end
        return text.replace(/\s*–\s*(Page|Seite)?\s*\d+\s*$/, '').trim();
    }

    function getElements() {
        if (!cache.elements) {
            const heading = document.querySelector(SELECTORS.heading);
            const title = document.querySelector(SELECTORS.title);

            cache.elements = {
                desc: document.querySelector(SELECTORS.desc),
                faq: document.querySelector(SELECTORS.faq),
                heading: heading,
                title: title
            };

            if (heading && !originalTexts.heading) {
                originalTexts.heading = stripPageNumber(heading.textContent.trim());
            }
            if (title && !originalTexts.title) {
                originalTexts.title = stripPageNumber(title.textContent.trim());
            }
        }
        return cache.elements;
    }

    function toggleElements() {
        const page = getPageParam();

        if (page === cache.page) return;
        cache.page = page;

        const {
            desc,
            faq,
            heading,
            title
        } = getElements();
        const isFirst = page === "1";
        const display = isFirst ? "" : "none";

        if (desc) desc.style.display = display;
        if (faq) faq.style.display = display;

        const pageText = getPageText();

        if (heading && originalTexts.heading) {
            heading.textContent = isFirst ?
                originalTexts.heading :
                `${originalTexts.heading} – ${pageText} ${page}`;
        }

        if (title && originalTexts.title) {
            title.textContent = isFirst ?
                originalTexts.title :
                `${originalTexts.title} – ${page}`;
        }
    }

    toggleElements();

    let timer;
    const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            cache.elements = null;
            toggleElements();
        }, 150);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    const patchHistory = (method) => {
        const orig = history[method];
        history[method] = function() {
            orig.apply(this, arguments);
            toggleElements();
        };
    };

    patchHistory("pushState");
    patchHistory("replaceState");
    window.addEventListener("popstate", toggleElements);
})();

// HIDE COLLECTION DESC, FAQ's UNLESS IT IS PAGE 1 //
// ---------------------END--------------------- //

// SCROLL TO TOP BUTTON ON COLLECTION //
// -------------START---------------- //

if (!window.location.pathname.includes('/products/')) {

    let scrollListener = null;

    function getScrollBtn() {
        return document.getElementById("scrollToTopBtn");
    }

    function updateScrollBtnVisibility() {
        const scrollBtn = getScrollBtn();
        if (!scrollBtn) return;

        const show = window.pageYOffset > 200;

        if (show) {
            scrollBtn.classList.add("show");
        } else {
            scrollBtn.classList.remove("show");
        }
    }

    function initScrollToTopBtn() {
        const scrollBtn = getScrollBtn();
        if (!scrollBtn) return;

        // avoid duplicate binding
        if (scrollBtn.dataset.bound === "true") return;
        scrollBtn.dataset.bound = "true";

        if (scrollListener) {
            window.removeEventListener("scroll", scrollListener);
        }

        scrollListener = updateScrollBtnVisibility;
        window.addEventListener("scroll", scrollListener, {
            passive: true
        });

        updateScrollBtnVisibility();

        scrollBtn.addEventListener("click", (e) => {
            e.preventDefault();

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    }

    const domObserver = new MutationObserver(() => {
        if (document.getElementById("scrollToTopBtn")) {
            initScrollToTopBtn();
        }
    });

    domObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    document.addEventListener("fdt:pagination:updated", () => {
        setTimeout(initScrollToTopBtn, 300);
    });
}

// PAGINATION CLICK HANDLER
document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-page]");
    if (!btn) return;
    if (btn.classList.contains("disabled")) return;
    if (btn.getAttribute("aria-disabled") === "true") return;

    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });

    setTimeout(() => {
        document.dispatchEvent(new CustomEvent("fdt:pagination:updated"));
    }, 800);
});

const STORAGE_KEY = "mobile_grid_layout";

function applyMobileGridLayout(value) {
    const resultsContainer = document.querySelector("fdt-search-product-results");
    if (!resultsContainer) return;

    if (value === "large") {
        resultsContainer.classList.add("search-filters__product-list-mobile-grid-1-col");
        resultsContainer.classList.remove("search-filters__product-list-mobile-grid-2-col");
    } else {
        resultsContainer.classList.add("search-filters__product-list-mobile-grid-2-col");
        resultsContainer.classList.remove("search-filters__product-list-mobile-grid-1-col");
    }
}

function getSavedLayout() {
    return localStorage.getItem(STORAGE_KEY);
}

function setSavedLayout(value) {
    localStorage.setItem(STORAGE_KEY, value);
}

function getActiveLayoutValue() {
    const activeBtn = document.querySelector(
        "collection-layout-switch[device='mobile'] .collection-toolbar__button.is-active"
    );

    return activeBtn ? activeBtn.value : "medium"; // default fallback
}

// Apply on page load
document.addEventListener("DOMContentLoaded", () => {
    const savedLayout = getSavedLayout();
    const initialLayout = savedLayout || getActiveLayoutValue();

    applyMobileGridLayout(initialLayout);

    // also sync UI state with saved value
    if (savedLayout) {
        const buttons = document.querySelectorAll(
            "collection-layout-switch[device='mobile'] .collection-toolbar__button"
        );

        buttons.forEach(btn => {
            btn.classList.toggle("is-active", btn.value === savedLayout);
        });
    }
});

// Apply on click
document.addEventListener("click", (e) => {
    const btn = e.target.closest(
        "collection-layout-switch[device='mobile'] .collection-toolbar__button"
    );
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const layoutSwitch = btn.closest("collection-layout-switch");

    // toggle off -> reset to default
    if (btn.classList.contains("is-active")) {
        btn.classList.remove("is-active");
        localStorage.removeItem(STORAGE_KEY);
        applyMobileGridLayout("medium");
        return;
    }

    // update active UI
    layoutSwitch.querySelectorAll(".collection-toolbar__button")
        .forEach(b => b.classList.remove("is-active"));

    btn.classList.add("is-active");

    // save + apply
    setSavedLayout(btn.value);
    applyMobileGridLayout(btn.value);
});

window.addEventListener('load', () => {
    const agent = document.querySelector('shopify-agent');
    if (!agent) return;

    const drawer = document.querySelector('.drawer'); // Change if needed
    const searchDisclosure = document.querySelector('.search-filters__disclosure');
    const wishlistDrawer = document.querySelector('.wishlist-drawer-show');

    const toggleChat = () => {
        const drawerOpen = drawer?.hasAttribute('open');
        const searchOpen = searchDisclosure?.hasAttribute('open');
        const wishlistOpen = wishlistDrawer?.classList.contains('show');

        agent.style.display = (drawerOpen || searchOpen || wishlistOpen) ? 'none' : '';
    };

    // Initial check
    toggleChat();

    if (drawer) {
        new MutationObserver(toggleChat).observe(drawer, {
            attributes: true,
            attributeFilter: ['open']
        });
    }

    if (searchDisclosure) {
        new MutationObserver(toggleChat).observe(searchDisclosure, {
            attributes: true,
            attributeFilter: ['open']
        });
    }

    if (wishlistDrawer) {
        new MutationObserver(toggleChat).observe(wishlistDrawer, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
});
/* ===== MK MENU v2: Ebene 2 auf Desktop, weiches Schließen, X-Toggle im Header ===== */

/* iOS: Tap auf Header-Icon während Nachscrollen/Einrasten → trotzdem öffnen */
(() => {
    const sel = '.header__primary-nav > button,.header__primary-nav > a,.header__secondary-nav li > a';
    let s = null;
    const anyOpen = () =>
        document.querySelector('#sidebar-menu[open],#cart-drawer[open],header-search[open]') ||
        document.documentElement.classList.contains('mk-wish-open');

    addEventListener('touchstart', e => {
        const el = e.target.closest(sel);
        s = (el && !anyOpen()) ? {
            el,
            x: e.touches[0].clientX,
            y: e.touches[0].clientY,
            t: Date.now(),
            ok: false
        } : null;
    }, {
        capture: true,
        passive: true
    });

    addEventListener('click', e => {
        if (s && e.target.closest(sel) === s.el) s.ok = true; // echter Klick kam an → nichts tun
    }, true);

    addEventListener('touchend', e => {
        const c = s,
            p = e.changedTouches[0];
        if (!c || Math.hypot(p.clientX - c.x, p.clientY - c.y) > 10 || Date.now() - c.t > 500) return;
        setTimeout(() => {
            if (!c.ok && !anyOpen()) c.el.click();
        }, 350);
    }, {
        capture: true,
        passive: true
    });
})();

customElements.whenDefined('header-sidebar').then(() => {
    const sb = document.getElementById('sidebar-menu');
    if (!sb || sb.dataset.mkInit || typeof sb.hide !== 'function') return;
    sb.dataset.mkInit = '1';

    const MS = 450;
    const desk = window.matchMedia('(min-width: 700px)');
    let closing = false,
        subTimer;

    const subPanels = () => sb.querySelectorAll('.header-sidebar__sub-panel');
    const l1Btns = () => sb.querySelectorAll('.header-sidebar__linklist-button[aria-controls^="header-panel-"]');

    function openSub(btn) {
        clearTimeout(subTimer);
        const id = btn.getAttribute('aria-controls');
        subPanels().forEach(p => {
            p.hidden = p.id !== id;
        });
        l1Btns().forEach(b => b.setAttribute('aria-expanded', String(b === btn)));
        const sc = sb.querySelector('.header-sidebar__collapsible-panel .header-sidebar__scroller');
        if (sc) sc.scrollTop = 0;
        requestAnimationFrame(() => sb.classList.add('mk-sub-open'));
    }

    function closeSub(instant) {
        clearTimeout(subTimer);
        sb.classList.remove('mk-sub-open');
        l1Btns().forEach(b => b.setAttribute('aria-expanded', 'false'));
        const hideAll = () => subPanels().forEach(p => {
            p.hidden = true;
        });
        instant ? hideAll() : (subTimer = setTimeout(hideAll, MS));
    }

    // Desktop: Ebene 1 → 2 selbst steuern (Mobile bleibt bei Prestige)
    sb.addEventListener('click', e => {
        if (!desk.matches) return;
        const btn = e.target.closest('.header-sidebar__linklist-button[aria-controls^="header-panel-"]');
        const back = e.target.closest('[data-action="close-panel"]');
        if (!btn && !back) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        btn ? openSub(btn) : closeSub();
    }, true);

    // Weiches Schließen: erst unsere Animation, dann das normale Prestige-hide
    const origHide = sb.hide.bind(sb);
    sb.hide = function(...args) {
        if (closing || !sb.hasAttribute('open')) return Promise.resolve();
        closing = true;
        sb.classList.add('mk-closing');
        return new Promise(res => setTimeout(() => {
            const r = origHide(...args);
            if (desk.matches) closeSub(true);
            closing = false;
            res(r);
        }, MS));
    };

    // Beim nächsten Öffnen die Schließ-Klasse entfernen
    new MutationObserver(() => {
        if (sb.hasAttribute('open') && !closing) sb.classList.remove('mk-closing');
    }).observe(sb, {
        attributes: true,
        attributeFilter: ['open']
    });

    // Hamburger/X im Header: ist das Menü offen, schließt ein Tap es
    const isToggle = t => t && t.closest && t.closest('[aria-controls="sidebar-menu"]') && !t.closest('#sidebar-menu');
    ['pointerdown', 'mousedown', 'touchstart'].forEach(type => {
        window.addEventListener(type, e => {
            if (!isToggle(e.target) || !sb.hasAttribute('open')) return;
            e.stopImmediatePropagation();
            if (type === 'pointerdown') sb.hide();
        }, {
            capture: true,
            passive: true
        });
    });
    window.addEventListener('click', e => {
        if (!isToggle(e.target) || !sb.hasAttribute('open')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        sb.hide();
    }, true);
});

/* ===== MK MENU: Öffnen + Schließen "aus der Pille" (per JS, Position bleibt) ===== */
customElements.whenDefined('header-sidebar').then(() => {
    const sb = document.getElementById('sidebar-menu');
    if (!sb || sb.dataset.mkPill) return;
    sb.dataset.mkPill = '1';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let closeAnim = null;

    const parts = () => {
        const root = sb.shadowRoot;
        if (!root) return {};
        return {
            content: root.querySelector('[part~="content"]'),
            inner: [root.querySelector('[part~="panel-list"]'), root.querySelector('[part~="header"]')].filter(Boolean)
        };
    };
    const shapes = () => {
        const cs = getComputedStyle(document.documentElement);
        const pill = parseFloat(cs.getPropertyValue('--mk-pill-h')) || 54;
        const radius = cs.getPropertyValue('--drop-r').trim() || '20px';
        return {
            pill: `inset(0 0 calc(100% - ${pill}px) 0 round ${pill / 2}px)`,
            full: `inset(0 0 0 0 round ${radius})`
        };
    };

    // Öffnen: wächst aus der Pille, federt nach
    const open = () => {
        const {
            content,
            inner
        } = parts();
        if (!content) return;
        if (closeAnim) {
            closeAnim.cancel();
            closeAnim = null;
        }
        if (reduce.matches) {
            content.animate([{
                opacity: 0
            }, {
                opacity: 1
            }], {
                duration: 200
            });
            return;
        }
        const s = shapes();
        content.animate([{
                clipPath: s.pill,
                opacity: 0
            },
            {
                opacity: 1,
                offset: 0.12
            },
            {
                clipPath: s.full,
                opacity: 1
            }
        ], {
            duration: 650,
            easing: 'cubic-bezier(.34,1.3,.64,1)'
        });
        inner.forEach(el => el.animate(
            [{
                opacity: 0
            }, {
                opacity: 0,
                offset: 0.35
            }, {
                opacity: 1
            }], {
                duration: 560,
                easing: 'ease-out'
            }
        ));
    };

    // Schließen: zieht sich zurück in die Pille (schneller, ohne Federn)
    const close = () => {
        const {
            content
        } = parts();
        if (!content) return;
        if (closeAnim) closeAnim.cancel();
        if (reduce.matches) {
            closeAnim = content.animate([{
                opacity: 1
            }, {
                opacity: 0
            }], {
                duration: 200,
                fill: 'forwards'
            });
            return;
        }
        const s = shapes();
        closeAnim = content.animate([{
                clipPath: s.full,
                opacity: 1
            },
            {
                opacity: 1,
                offset: 0.7
            },
            {
                clipPath: s.pill,
                opacity: 0
            }
        ], {
            duration: 400,
            easing: 'cubic-bezier(.32,.72,0,1)',
            fill: 'forwards'
        });
    };

    let wasOpen = sb.hasAttribute('open');
    let wasClosing = sb.classList.contains('mk-closing');
    new MutationObserver(() => {
        const isOpen = sb.hasAttribute('open');
        const isClosing = sb.classList.contains('mk-closing');
        if (isOpen && !wasOpen) requestAnimationFrame(open);
        if (isClosing && !wasClosing && isOpen) close();
        wasOpen = isOpen;
        wasClosing = isClosing;
    }).observe(sb, {
        attributes: true,
        attributeFilter: ['open', 'class']
    });
});
/* ===== MK CART: wie das Menü – aus der Pille, Icon wird zum X, weiches Schließen ===== */
customElements.whenDefined('cart-drawer').then(() => {
    const cd = document.getElementById('cart-drawer');
    if (!cd || cd.dataset.mkPill || typeof cd.hide !== 'function') return;
    cd.dataset.mkPill = '1';

    const MS = 450;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let closing = false,
        closeAnims = [];

    // X ins Warenkorb-Icon im Header einsetzen (zwei Linien, drehen sich wie beim Hamburger)
    document.querySelectorAll('.header__cart-link > a[aria-controls="cart-drawer"]').forEach(a => {
        if (a.querySelector('.mk-cart-x')) return;
        a.insertAdjacentHTML('beforeend',
            '<svg class="mk-cart-x" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path class="a" d="M4 12h16"/><path class="b" d="M4 12h16"/></svg>');
    });

    const parts = () => {
        const root = cd.shadowRoot;
        if (!root) return {};
        return {
            content: root.querySelector('[part~="content"]'),
            inner: ['header', 'body', 'footer'].map(p => root.querySelector(`[part~="${p}"]`)).filter(Boolean)
        };
    };
    const shapes = () => {
        const cs = getComputedStyle(document.documentElement);
        const pill = parseFloat(cs.getPropertyValue('--mk-pill-h')) || 54;
        const radius = cs.getPropertyValue('--drop-r').trim() || '20px';
        return {
            pill: `inset(0 0 calc(100% - ${pill}px) 0 round ${pill / 2}px)`,
            full: `inset(0 0 0 0 round ${radius})`
        };
    };
    const cancelClose = () => {
        closeAnims.forEach(a => a.cancel());
        closeAnims = [];
    };

    // Öffnen: wächst aus der Pille, federt nach (gleiche Werte wie das Menü)
    const open = () => {
        const {
            content,
            inner
        } = parts();
        if (!content) return;
        cancelClose();
        if (reduce.matches) {
            content.animate([{
                opacity: 0
            }, {
                opacity: 1
            }], {
                duration: 200
            });
            return;
        }
        const s = shapes();
        content.animate([{
                clipPath: s.pill,
                opacity: 0
            },
            {
                opacity: 1,
                offset: 0.12
            },
            {
                clipPath: s.full,
                opacity: 1
            }
        ], {
            duration: 650,
            easing: 'cubic-bezier(.34,1.3,.64,1)'
        });
        inner.forEach(el => el.animate(
            [{
                opacity: 0
            }, {
                opacity: 0,
                offset: 0.35
            }, {
                opacity: 1
            }], {
                duration: 560,
                easing: 'ease-out'
            }
        ));
    };

    // Schließen: Inhalt blendet aus, Panel zieht sich in die Pille zurück
    const close = () => {
        const {
            content,
            inner
        } = parts();
        if (!content) return;
        cancelClose();
        if (reduce.matches) {
            closeAnims.push(content.animate([{
                opacity: 1
            }, {
                opacity: 0
            }], {
                duration: 200,
                fill: 'forwards'
            }));
            return;
        }
        const s = shapes();
        inner.forEach(el => closeAnims.push(
            el.animate([{
                opacity: 1
            }, {
                opacity: 0
            }], {
                duration: 160,
                easing: 'ease',
                fill: 'forwards'
            })
        ));
        closeAnims.push(content.animate([{
                clipPath: s.full,
                opacity: 1
            },
            {
                opacity: 1,
                offset: 0.7
            },
            {
                clipPath: s.pill,
                opacity: 0
            }
        ], {
            duration: 400,
            easing: 'cubic-bezier(.32,.72,0,1)',
            fill: 'forwards'
        }));
    };

    // Weiches Schließen: erst unsere Animation, dann Prestiges normales hide()
    const origHide = cd.hide.bind(cd);
    cd.hide = function(...args) {
        if (closing || !cd.hasAttribute('open')) return Promise.resolve();
        closing = true;
        cd.classList.add('mk-closing'); // X dreht sofort zurück zum Icon
        close();
        return new Promise(res => setTimeout(() => {
            const r = origHide(...args);
            closing = false;
            res(r);
        }, MS));
    };

    // Bei jedem Öffnen (auch nach "In den Warenkorb"): Pillen-Animation
    let wasOpen = cd.hasAttribute('open');
    new MutationObserver(() => {
        const isOpen = cd.hasAttribute('open');
        if (isOpen && !wasOpen) {
            cd.classList.remove('mk-closing');
            requestAnimationFrame(open);
        }
        wasOpen = isOpen;
    }).observe(cd, {
        attributes: true,
        attributeFilter: ['open']
    });

    // Warenkorb-Icon / X im Header: ist der Warenkorb offen, schließt ein Tap ihn
    const isToggle = t => t && t.closest && t.closest('[aria-controls="cart-drawer"]') && !t.closest('#cart-drawer');
    ['pointerdown', 'mousedown', 'touchstart'].forEach(type => {
        window.addEventListener(type, e => {
            if (!isToggle(e.target) || !cd.hasAttribute('open')) return;
            e.stopImmediatePropagation();
            if (type === 'pointerdown') cd.hide();
        }, {
            capture: true,
            passive: true
        });
    });
    window.addEventListener('click', e => {
        if (!isToggle(e.target) || !cd.hasAttribute('open')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        cd.hide();
    }, true);
});
/* Menü + Warenkorb exakt so breit wie der Header (misst den Header aus) */
(() => {
    const sync = () => {
        const h = document.querySelector('.shopify-section--header .header');
        if (!h) return;
        const r = h.getBoundingClientRect();
        const s = document.documentElement.style;
        s.setProperty('--mk-hdr-l', r.left + 'px');
        s.setProperty('--mk-hdr-w', r.width + 'px');
    };
    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    ['sidebar-menu', 'cart-drawer'].forEach(id => {
        const el = document.getElementById(id);
        if (el) new MutationObserver(sync).observe(el, {
            attributes: true,
            attributeFilter: ['open']
        });
    });
})();
/* ===== MK WISHLIST (iWish): Karte wächst aus dem Header wie der Filter aus dem Dock, Herz wird zum X ===== */
(() => {
    const root = document.documentElement;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const SPRING = 'cubic-bezier(.34,1.3,.64,1)'; // = Filter-Card
    const SMOOTH = 'cubic-bezier(.32,.72,0,1)';
    let bypass = false,
        closing = false,
        wasOpen = false;

    const panel = () => document.querySelector('.iwish-drawer-menu');
    const isOpen = () => !!document.querySelector('.wishlist-drawer-show.show');

    // --- MUTUAL EXCLUSIVITY: Helper to close Menu, Cart, and Search ---
    const closeOthers = () => {
        const sb = document.getElementById('sidebar-menu');
        if (sb && sb.hasAttribute('open')) {
            typeof sb.hide === 'function' ? sb.hide() : sb.removeAttribute('open');
        }

        const cd = document.getElementById('cart-drawer');
        if (cd && cd.hasAttribute('open')) {
            typeof cd.hide === 'function' ? cd.hide() : cd.removeAttribute('open');
        }

        const hs = document.querySelector('header-search');
        if (hs && hs.hasAttribute('open')) {
            typeof hs.hide === 'function' ? hs.hide() : hs.removeAttribute('open');
        }
    };

    // X in die Herz-Links im Header einsetzen
    const addX = () => document.querySelectorAll('.iwishDrawer').forEach(a => {
        if (a.querySelector('.mk-wish-x')) return;
        a.insertAdjacentHTML('beforeend',
            '<svg class="mk-wish-x" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path class="a" d="M4 12h16"/><path class="b" d="M4 12h16"/></svg>');
    });
    addX();

    // Öffnen: wächst von oben aus dem Header (Filter-Bewegung, nur umgedreht)
    const openAnim = () => {
        const p = panel();
        if (!p) return;
        p.getAnimations().forEach(a => a.cancel());
        if (reduce.matches) {
            p.animate([{
                opacity: 0
            }, {
                opacity: 1
            }], {
                duration: 200
            });
            return;
        }
        p.animate([{
            opacity: 0
        }, {
            opacity: 1
        }], {
            duration: 220,
            easing: 'ease'
        });
        p.animate([{
                scale: '.62 .16',
                translate: '0 -10px'
            },
            {
                scale: '1',
                translate: '0 0'
            }
        ], {
            duration: 500,
            easing: SPRING
        });
    };

    // Schließen: zieht sich nach oben zurück, danach schließt iWish ganz normal
    const doClose = () => {
        if (closing) return;
        closing = true;
        root.classList.remove('mk-wish-open'); // X dreht sofort zurück zum Herz
        const p = panel();
        const finish = () => {
            bypass = true;
            const btn = document.querySelector('.iwish_drawer_close, .mst-drawer-title-icon');
            if (btn) btn.click();
            else document.querySelector('.iwish-backdrop')?.click();
            bypass = false;
            closing = false;
        };
        if (!p || reduce.matches) return finish();
        p.animate([{
            opacity: 1
        }, {
            opacity: 0
        }], {
            duration: 220,
            delay: 80,
            easing: 'ease',
            fill: 'forwards'
        });
        p.animate([{
                scale: '1',
                translate: '0 0'
            },
            {
                scale: '.62 .16',
                translate: '0 -10px'
            }
        ], {
            duration: 300,
            easing: SMOOTH,
            fill: 'forwards'
        });
        setTimeout(finish, 300);
    };

    // Helper: iWish schließen, wenn es aktuell geöffnet ist
    const closeWishlist = () => {
        if (isOpen()) doClose();
    };

    // 1. Klick auf Menü-, Warenkorb- oder Such-Trigger schließt iWish sofort
    const otherTriggers = '[aria-controls="sidebar-menu"], [aria-controls="cart-drawer"], [aria-controls*="search"], header-search';
    window.addEventListener('click', e => {
        if (isOpen() && e.target.closest(otherTriggers)) {
            closeWishlist();
        }
    }, true);

    // 2. Klick auf iWish-Trigger schließt andere sofort
    window.addEventListener('click', e => {
        if (e.target.closest('.iwishDrawer') && !isOpen()) {
            closeOthers();
        }
    }, true);

    // 3. Observer: Sobald Menü, Warenkorb oder Suche das 'open'-Attribut erhalten (auch per Add-to-Cart) -> iWish schließen
    const watchForOpen = selector => {
        const el = document.querySelector(selector);
        if (!el || el.dataset.mkWishWatch) return;
        el.dataset.mkWishWatch = '1';
        new MutationObserver(() => {
            if (el.hasAttribute('open')) closeWishlist();
        }).observe(el, {
            attributes: true,
            attributeFilter: ['open']
        });
    };

    const initWatchers = () => {
        ['#sidebar-menu', '#cart-drawer', 'header-search'].forEach(watchForOpen);
    };
    initWatchers();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWatchers);
    }

    // Overlay, iWish-X und Herz/X im Header: erst unsere Animation, dann zu
    window.addEventListener('click', e => {
        if (bypass || !isOpen()) return;
        const t = e.target;
        const hit = t.closest('.iwish_drawer_close, .iwish-backdrop') ||
            (t.closest('.iwishDrawer') && !t.closest('.iwish-drawer-menu'));
        if (!hit) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        doClose();
    }, true);

    // Öffnen erkennen (iWish setzt .show), auch wenn iWish den Drawer erst später einbaut
    const check = () => {
        const now = isOpen();
        if (now && !wasOpen) {
            root.classList.add('mk-wish-open');
            closeOthers(); // <--- Schließt Menü, Cart und Search, sobald iWish öffnet
            addX();
            requestAnimationFrame(openAnim);
        }
        if (!now && wasOpen) root.classList.remove('mk-wish-open');
        wasOpen = now;
    };
    let watchedDrawer = null;
    const drawerObserver = new MutationObserver(check);

    const watchDrawer = (drawer) => {
        if (drawer === watchedDrawer) return;

        drawerObserver.disconnect();
        watchedDrawer = drawer;

        if (drawer) {
            drawerObserver.observe(drawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }

        check();
    };

    // Die App kann den Drawer später einfügen oder ersetzen.
    new MutationObserver((records) => {
        if (watchedDrawer && !watchedDrawer.isConnected) {
            watchDrawer(null);
        }

        for (const record of records) {
            for (const node of record.addedNodes) {
                if (node.nodeType !== 1) continue;

                const drawer = node.matches('.wishlist-drawer-show')
                    ? node
                    : node.querySelector('.wishlist-drawer-show');

                if (drawer) watchDrawer(drawer);
            }
        }
    }).observe(document.body, {
        childList: true,
        subtree: true
    });

    watchDrawer(document.querySelector('.wishlist-drawer-show'));
})();

/* ===== MK SEARCH: Lupe wird zum X, Tap aufs X schließt die Suche ===== */
customElements.whenDefined('header-search').then(() => {
    const hs = document.querySelector('header-search');
    if (!hs || hs.dataset.mkX) return;
    hs.dataset.mkX = '1';
    const id = hs.id;

    // X in den Lupen-Link im Header einsetzen
    document.querySelectorAll(`a[aria-controls="${id}"]`).forEach(a => {
        if (a.querySelector('.mk-search-x')) return;
        a.insertAdjacentHTML('beforeend',
            '<svg class="mk-search-x" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path class="a" d="M4 12h16"/><path class="b" d="M4 12h16"/></svg>');
    });

    if (typeof hs.hide !== 'function') return;
    const isToggle = t => t && t.closest && t.closest(`[aria-controls="${id}"]`) && !t.closest('header-search');
    let justClosed = false;

    // Antippen bei offener Suche: schließen und den folgenden Klick blockieren
    ['pointerdown', 'mousedown', 'touchstart'].forEach(type => {
        window.addEventListener(type, e => {
            if (!isToggle(e.target) || (!hs.hasAttribute('open') && !justClosed)) return;
            e.stopImmediatePropagation();
            if (type === 'pointerdown' && hs.hasAttribute('open')) {
                justClosed = true;
                hs.hide();
                setTimeout(() => {
                    justClosed = false;
                }, 500);
            }
        }, {
            capture: true,
            passive: true
        });
    });
    window.addEventListener('click', e => {
        if (!isToggle(e.target)) return;
        if (justClosed || hs.hasAttribute('open')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (hs.hasAttribute('open')) hs.hide();
        }
    }, true);

    // Menü/Warenkorb offen + Tap auf die Lupe: die anderen zu, Suche SOFORT auf (wie Warenkorb/Wishlist)
    window.addEventListener('click', e => {
        if (!isToggle(e.target) || hs.hasAttribute('open') || justClosed) return;
        const others = ['sidebar-menu', 'cart-drawer']
            .map(id => document.getElementById(id))
            .filter(d => d && d.hasAttribute('open') && typeof d.hide === 'function');
        if (!others.length) return; // nichts offen → Prestige macht es wie immer
        e.preventDefault();
        e.stopImmediatePropagation();
        const waits = others.map(d => d.hide());
        hs.show();
        // falls das verzögerte Schließen der anderen die Suche wieder zumacht: sofort wieder öffnen
        Promise.all(waits).then(() => {
            if (!hs.hasAttribute('open')) hs.show();
        });
    }, true);
});
/* Warenkorb: weicher Verlauf unten, solange es weiter nach unten geht */
customElements.whenDefined('cart-drawer').then(() => {
    const cd = document.getElementById('cart-drawer');
    if (!cd || !cd.shadowRoot || cd.dataset.mkFade) return;
    cd.dataset.mkFade = '1';
    const root = cd.shadowRoot;
    const content = root.querySelector('[part~="content"]');
    const body = root.querySelector('[part~="body"]');
    const more = el => el && (el.scrollHeight - el.scrollTop - el.clientHeight > 8);

    const update = () => {
        const c = more(content); // kleines Handy: ganzer Warenkorb scrollt
        cd.classList.toggle('mk-more-c', c);
        cd.classList.toggle('mk-more-b', !c && more(body)); // größer: nur die Artikel scrollen
    };

    [content, body].forEach(el => el && el.addEventListener('scroll', update, {
        passive: true
    }));
    window.addEventListener('resize', update);
    new MutationObserver(() => {
        requestAnimationFrame(update);
        setTimeout(update, 700); // nach der Öffnen-Animation nochmal messen
    }).observe(cd, {
        attributes: true,
        attributeFilter: ['open'],
        childList: true,
        subtree: true
    });
});
/* Mobile: beim Browser-Zurück zum zuvor geöffneten Produkt zurückkehren. */
(() => {
  if (!location.pathname.includes('/collections/') ||
      location.pathname.includes('/products/')) return;

  const mobile = () => matchMedia('(max-width: 699px)').matches;
  const storageKey = () => 'mk-collection-return:' + location.href;

  document.addEventListener('click', (event) => {
    if (!mobile() || event.defaultPrevented || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('#fdt-container a[href]');
    const card = link?.closest('.search-filters__product-item');
    if (!link || !card || link.target === '_blank') return;

    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin ||
        !target.pathname.includes('/products/')) return;

    try {
      sessionStorage.setItem(storageKey(), JSON.stringify({
        path: target.pathname,
        top: card.getBoundingClientRect().top,
        y: window.scrollY,
        width: document.documentElement.clientWidth,
        time: Date.now()
      }));
    } catch (_) {}
  });

  let stopPrevious = () => {};

  const restore = (event) => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!mobile() || !(event?.persisted || navigation?.type === 'back_forward')) return;

    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey())); }
    catch (_) { return; }

    if (!saved || !Number.isFinite(saved.y) || !Number.isFinite(saved.top) ||
        Date.now() - saved.time > 30 * 60 * 1000 ||
        Math.abs(saved.width - document.documentElement.clientWidth) > 2) return;

    stopPrevious();
    const sourceURL = location.href;
    let stopped = false;
    let frame = 0;
    const timers = [];
    let resize;

    const stop = () => {
      if (stopped) return;
      stopped = true;
      cancelAnimationFrame(frame);
      timers.forEach(clearTimeout);
      resize?.disconnect();
      document.removeEventListener('findter-products-render-after', schedule);
      document.removeEventListener('touchstart', stop, true);
      document.removeEventListener('pointerdown', stop, true);
      document.removeEventListener('wheel', stop, true);
      document.removeEventListener('keydown', stop, true);
      window.removeEventListener('pagehide', stop);
    };

    const apply = () => {
      frame = 0;
      if (stopped) return;
      if (location.href !== sourceURL || !mobile()) return stop();

      const cards = document.querySelectorAll(
        '#fdt-container .search-filters__product-item'
      );
      const card = Array.from(cards).find((item) =>
        Array.from(item.querySelectorAll('a[href]')).some((link) => {
          try { return new URL(link.href).pathname === saved.path; }
          catch (_) { return false; }
        })
      );
      if (!card || !card.getClientRects().length) return;

      const desired = Math.max(
        0, window.scrollY + card.getBoundingClientRect().top - saved.top
      );
      if (Math.abs(window.scrollY - desired) > 2) {
        window.scrollTo({ top: desired, behavior: 'instant' });
      }
    };

    function schedule() {
      if (!stopped && !frame) frame = requestAnimationFrame(apply);
    }

    stopPrevious = stop;
    document.addEventListener('findter-products-render-after', schedule);
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach((name) => {
      document.addEventListener(name, stop, { capture: true, passive: true });
    });
    window.addEventListener('pagehide', stop, { once: true });

    const container = document.getElementById('fdt-container');
    if (container) {
      resize = new ResizeObserver(schedule);
      resize.observe(container);
    }
    [0, 150, 500, 1000, 2000, 4000].forEach((delay) => {
      timers.push(setTimeout(schedule, delay));
    });
    timers.push(setTimeout(stop, 6000));
  };

  window.addEventListener('pageshow', restore);
  if (document.readyState === 'complete') restore();
})();

/* Warenkorb: verfügbare Höhe für eine vollständige Artikelzeile prüfen */
(() => {
  let frame = 0;
  const watched = new WeakSet();

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(check);
  };

  const observer = new ResizeObserver(schedule);

  function check() {
    frame = 0;

    const cart = document.querySelector('#cart-drawer');
    const shadow = cart?.shadowRoot;
    if (!shadow) return;

    const content = shadow.querySelector('[part~="content"]');
    const header = shadow.querySelector('[part~="header"]');
    const body = shadow.querySelector('[part~="body"]');
    const footer = shadow.querySelector('[part~="footer"]');
    const items = cart.querySelector('.cart-drawer__items');
    const rows = items?.querySelectorAll('.line-item');

    [content, header, body, footer, items].forEach((element) => {
      if (!element || watched.has(element)) return;
      watched.add(element);
      observer.observe(element);
    });

    if (!content?.clientHeight || !body || !rows?.length) return;

    const number = (value) => parseFloat(value) || 0;
    const box = getComputedStyle(content);
    const inner = getComputedStyle(body);

    const available =
      content.clientHeight -
      (header?.getBoundingClientRect().height || 0) -
      (footer?.getBoundingClientRect().height || 0) -
      number(box.paddingTop) -
      number(box.paddingBottom) -
      number(box.rowGap) * 2 -
      number(inner.paddingTop) -
      number(inner.paddingBottom);

    const required = Math.max(
      ...Array.from(rows, (row) => row.getBoundingClientRect().height)
    );

    const active = cart.classList.contains('mk-cart-full-scroll');

    /* Kleiner Puffer verhindert Hin-und-her-Umschalten. */
    cart.classList.toggle(
      'mk-cart-full-scroll',
      available < required + (active ? 16 : 8)
    );
  }

  const start = () => {
    const cart = document.querySelector('#cart-drawer');
    if (!cart) return;

    new MutationObserver(schedule).observe(cart, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });

    window.addEventListener('resize', schedule, { passive: true });
    cart.addEventListener('load', schedule, true);
    document.fonts?.ready.then(schedule);
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* MK PDP (Produktseite) liegt jetzt in assets/mk-pdp.js – wird nur auf der Produktseite geladen. */
